import { Component, OnInit,ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { MdlTextFieldComponent  } from '../../lib/components';
import { MdlDialogService ,MdlDialogReference } from '../../lib/components/dialog/index';
import { RegisterService  } from '../service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

    @ViewChild('firstElement')  private inputElement: MdlTextFieldComponent;
     public registerForm: FormGroup;
    errorMessage: string;
  public processingLogin = false;
  public statusMessage = '';
  public userImg:File;
  public userProfileImg:File;
  public ControtyOpt:Array<any> = [];
  public StateOpt:Array<any> = [];
  public photoImg:string="";
  public IdProofImg:string="";
  constructor(private _location: Location,private fb: FormBuilder, public _registerService :RegisterService,private dialogService: MdlDialogService) { }
  ngOnInit() {
     this.registerForm =  this.fb.group({
      'firstName' : [null, Validators.required],
      'lastName' : [null, Validators.required],
      'UserPhoto':[null],
      'username' : [null, Validators.required],
      'userPassword' : [null, Validators.required],
      'userConfPassword' : [null, Validators.required],
      'UserIDProof':[null],
      'GenerallBuisnessTerms': [null, Validators.required],
      'GenerallBuisnessTerms2': [null, Validators.required],
    })
    this.inputElement.setFocus(); 
  }
 submitForm(){
    this.processingLogin = true;
    this.statusMessage = 'checking your credentials ...';
    if(this.registerForm.value.userPassword!=this.registerForm.value.userConfPassword){
          this.alertMsg("","confirmed password not match");
           return false;
    }else if(this.userImg==null){
       this.alertMsg("","Please upload user photo");
          return false;
    }else if(this.userProfileImg==null){
          this.alertMsg("","Please select User ID Photo");
          return false;
    } 
    this._registerService.UserRegister(this.registerForm.value,this.userImg,this.userProfileImg)
                .subscribe(user=>this.onSuccess(user),error => this.errorMessage = <any>error);
 }
 alertMsg(title,message){
    let pDialog = this.dialogService.showDialog({
          title: title,
          message: message,
          actions: [
            {
              handler: () => {
                       this.processingLogin = false;
                       this.statusMessage = '';
                },
                text: 'ok' ,
                isClosingAction: false
              }
            ],
            fullWidthAction: true,
            isModal: false,
            animate: false
          });
          pDialog.subscribe( (dialogReference) => console.log('dialog visible', dialogReference) );
 }
 onSuccess(data:any){
     this.processingLogin = false;
     this.statusMessage = '';
     this.alertMsg("",data.mes);
     this.registerForm.reset();
     this.photoImg="";
     this.IdProofImg="";
     this._location.back();
 }
 onCheckEmailId(){
   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   if(re.test(this.registerForm.value.username)){
      this._registerService.isCheckEmail(this.registerForm.value.username)
                .subscribe(user=>this.setEmailStatus(user.success),error => this.errorMessage = <any>error);
   }
 }
 setEmailStatus(status:String){
   if(status){
     this.alertMsg("","Email is already registered");
   }
 }
  setUserPhoto(Photo:File){  
    this.registerForm.value.UserPhoto=Photo;
    this.userImg=Photo;
   // this.loginForm.value.UserPhoto=Photo;
  }
  setUserIDProof(Photo:File){  
    this.registerForm.value.UserIDProof=Photo;
    this.userProfileImg=Photo;
   // this.loginForm.value.UserPhoto=Photo;
  }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts